<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <span *ngIf="jobOrders.length == 1">
    <div class="h3">This purchase order only has a single Job Order associated with it.</div>
  </span>
  <span *ngIf="jobOrders.length > 1">
    <div class="h3 mb-3">Job Orders on Purchase Order: {{ poHeader.id }}</div>
    <app-ag-grid gridId="splitPurchaseOrdersGrid" style="height: 300px" [gridOptions]="joGridOptions" [rowData]="jobOrders"></app-ag-grid>
  </span>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button id="splitOkButton" *ngIf="isPageReady && jobOrders.length > 1" (click)="ok()" pButton type="button" class="p-button-raised">
      Ok
    </button>
    <button id="splitCancelButton" (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
